/** When Stick is on, navigating must leave the hamburger open. */
export function shouldCloseSidebarOnNavigate(stuck: boolean): boolean {
  return !stuck;
}
